package top.wcpe.allincore.ui.runtime.internal.debug

/** JS：web-preview 无 dev-debug 面板，恒非 verbose（异常日志不附堆栈）。 */
internal actual fun uiVerbose(): Boolean = false

internal actual fun uiDebugEnabled(): Boolean = false

/** JS：简单 (tag,payload) 去重（无 dev-debug 面板联动）。 */
private val onceSeen = HashSet<String>()

internal actual fun uiDebugOnce(tag: String, payload: Any?, emit: () -> Unit) {
    if (onceSeen.add("$tag $payload")) emit()
}
